module.exports = __webpack_public_path__ + "static/media/avatar-portrait.ec403bd1.png";